module.exports = __webpack_public_path__ + "img/yc-logo-yescoin.png";